import React from 'react';
import Divider from '@fuww/library/src/Login/Divider';
import withApollo from '../lib/apollo';
import { CaptchaProvider } from '../components/Captcha';
import SignupComponent from '../components/LoginSignup/Signup';
import SignupForm from '../components/LoginSignup/SignupForm';
import { useSiteContext } from '../components/SiteContext';
import SignupWithProviderForm
  from '../components/LoginSignup/SignupWithProviderForm';
import RedirectWhenLoggedIn
  from '../components/LoginSignup/RedirectWhenLoggedIn';
import { Registrar } from '../lib/graphql/api/graphql';

export const Signup = () => {
  const { dashboard } = useSiteContext();
  const registeredVia = dashboard ? Registrar.DASHBOARD : Registrar.PWA;

  return (
    <CaptchaProvider>
      <SignupComponent
        showBreadcrumbs={!dashboard}
      >
        <SignupForm registeredVia={registeredVia} />
        <Divider dividerText="OR CONTINUE WITH" />
        <SignupWithProviderForm
          provider="google"
        />
        <SignupWithProviderForm
          provider="linkedin"
        />
        <RedirectWhenLoggedIn />
      </SignupComponent>
    </CaptchaProvider>
  );
};

export default withApollo(Signup);
